class SelectedWasteSummary {
    constructor(selectedWasteProducts){
        // Dummy Data -- all variable names are assumed, feel free to change them
        selectedWasteProducts = groupBy(selectedWasteProducts, 'waste_stream_setting_id')


        var selectedWasteStreams = []
        for(var wasteStreamSettingId in selectedWasteProducts){
            selectedWasteStream = selectedWasteProducts[wasteStreamSettingId]
            var id = -1
            var qty = 0
            var apiValue = null;
            var maxPerCollection = -1
            var wasteVariations = []

            for(var index in selectedWasteStream){
                var wasteVariation = selectedWasteStream[index]
                if(id == -1){
                    id = wasteVariation.waste_stream_setting_id
                    maxPerCollection = wasteVariation.max_per_collection
                    apiValue = wasteVariation.apiValue
                }
                qty += wasteVariation.qty
                
                wasteVariations.push(wasteVariation)
            }
            selectedWasteStreams.push({
                id, qty, apiValue, maxPerCollection, wasteVariations
            })
        }
        
        // Format as 
        this.selectedWasteStreams = selectedWasteStreams
    }
    
    get values(){
        return {

        }
    }

    calculateGreatestMaxRatio(){
        // Note: All this can be moved to classes later on, when less complicated

        // Step 1. Get Max Ratio for each steam
        var greatestMaxRatio = {
            ratio : 0
        }
        this.selectedWasteStreams.forEach(wasteStream =>{

            // Using Count, calculate for the consumption ration
            var maxRatio = wasteStream.qty / wasteStream.maxPerCollection
            if(greatestMaxRatio.ratio < maxRatio){
                greatestMaxRatio.ratio = maxRatio
            }
        })

        // Round Up
        // Step 2. See if the Highest maxRatio is greater than 1
        return Math.ceil(greatestMaxRatio.ratio)

         // Check for Free Entitlements

                    // 1. Calculate sum of Waste Streams
                    //     - either all variations or itself
                    // 2. Divide all sums by the waste stream max (settings)
                    // 3. Get the highest ratio
                    // 4. Check multiple collection value. If it's less, prompt user
    }

    filterBookingDates(bookingDates){
        var filteredDates = [];
        filteredDates = bookingDates.filter(bookingDate =>{
            return true;
        })
        return filteredDates;
    }
}

function groupBy(xs, key) {
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x)
        return rv
    }, {})
}
module.exports = SelectedWasteSummary